import axios from 'axios'
import Promise from 'bluebird'
import { reset } from 'redux-form'
import omit from 'lodash/omit'
import { List, fromJS } from 'immutable'
import NProgress from 'nprogress/nprogress.js'
import Notifications from 'react-notification-system-redux'
import initializers from '../dependencies/initializers'
import { globalHideSweetAlert,globalAddSweetAlertData } from './global'

import { globalConcatImmutableData } from '../helpers/global'
import { assessment } from '../reducers/assessments'

require('es6-promise').polyfill()

export function assessmentFetchDataSuccess(assessments) {
	return {
		type: 'ASSESSMENTS_FETCH_DATA_SUCCESS',
		assessments
	}
}


export function assessmentGetDetailSuccess(assessment) {
	return {
		type: 'ASSESSMENTS_GET_DETAIL_SUCCESS',
		assessment
	}
}


export function assessmentAddFilterPageNumberSuccess(page) {
	return {
		type: 'ASSESSMENTS_ADD_FILTER_PAGE_NUMBER_SUCCESS',
		page
	}
}


export function assessmentAddFilterSortSuccess(sort) {
	return {
		type: 'ASSESSMENTS_ADD_FILTER_SORT_SUCCESS',
		sort
	}
}

export function assessmentAddFilterSearchSuccess(search) {
	return {
		type: 'ASSESSMENTS_ADD_FILTER_SEARCH_SUCCESS',
		search
	}
}

export function assessmentClearFilterDataSuccess() {
	return {
		type: 'ASSESSMENTS_CLEAR_FILTER_DATA_SUCCESS'
	}
}


export function assessmentFetchPaginationSuccess(pagination) {
	return {
		type: 'ASSESSMENTS_FETCH_PAGINATION_SUCCESS',
		pagination
	}
}

export function assessmentAddFilterTestTypeSuccess(test_type) {
	return {
		type: 'ASSESSMENTS_ADD_FILTER_TEST_TYPE_SUCCESS',
		test_type
	}
}
export function assessmentAddFilterJobRoleSuccess(role) {
	return {
		type: 'ASSESSMENTS_ADD_FILTER_JOB_ROLE_SUCCESS',
		job_role: role
	}
}
export function assessmentAddFilterJobLevelSuccess(level) {
	return {
		type: 'ASSESSMENTS_ADD_FILTER_JOB_LEVEL_SUCCESS',
		job_level: level
	}
}


export function assessmentAddFilterPageNumber(page) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentAddFilterPageNumberSuccess(page)))
		})
	}
}

export function assessmentAddFilterSort(sort) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentAddFilterSortSuccess(sort)))
		})
	}
}

export function assessmentAddFilterSearch(fullname) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentAddFilterSearchSuccess(fullname)))
		})
	}
}


export function assessmentFetchDetail(assessment) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentGetDetailSuccess(assessment)))
		})
	}
}


export function assessmentClearFilterData() {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentClearFilterDataSuccess()))
		})
	}
}

export function assessmentAddFilterTestType(type) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentAddFilterTestTypeSuccess(type)))
		})
	}
}

export function assessmentAddFilterJobRole(role) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentAddFilterJobRoleSuccess(role)))
		})
	}
}

export function assessmentAddFilterJobLevel(level) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(assessmentAddFilterJobLevelSuccess(level)))
		})
	}
}


/**
 * Fetches assessment data from the API based on the provided filter data.
 * Dispatches actions to update the store with the fetched assessments and pagination info.
 * Shows a loading progress bar during the request.
 *
 * @param {Immutable.Map} filterData - The filter criteria as an Immutable.js Map.
 * @returns {Function} Thunk function to be handled by Redux Thunk middleware.
 */
export function assessmentFetchData(filterData) {
	return (dispatch) => {
		NProgress.start()
		let url = initializers.api_host+`/public/assessment/filter`
		return axios({
			url,
			timeout: 20000,
			method: 'post',
			responseType: 'json',
			headers: {'X-Requested-With': 'XMLHttpRequest'},
			params: filterData.toJS()
		})
		.then((response) => {
			NProgress.done()
			const assessments = response.data.data.data
			const pagination = omit(response.data.data, 'data')
			console.log('PAGINATION', pagination);
			console.log('ASSESSMENT', assessments);
			dispatch(assessmentFetchPaginationSuccess(pagination))
			dispatch(assessmentFetchDataSuccess(assessments))
		})
		.catch((error) => {
			NProgress.done()
			console.error(error)
		})
	}
}


/**
 * Fetches the details of an assessment by its ID with optional filter parameters.
 *
 * @param {string|number} assessmentId - The unique identifier of the assessment.
 * @param {Object} [filter_data={}] - Optional filter parameters to include in the request.
 * @returns {Function} A thunk action that returns a Promise resolving to the assessment details.
 */
export function assessmentGetDetail(assessmentId, filter_data={}) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			axios({
				url: initializers.api_host+`/public/assessment/${assessmentId}/detail`,
				timeout: 20000,
				method: 'post',
				responseType: 'json',
				params: filter_data
			})
			.then((response) => {
				const assessment = response.data.data
				console.log('ASSESSMENT DETAIL', assessment)
				dispatch(assessmentGetDetailSuccess(assessment))
				resolve(assessment)
			})
			.catch((error) => {
				console.error(error)
			})
		})
	}
}

